import { useEffect, useState } from "react";
import ProductosHeader from "./components/ProductosHeader";
import ProductosFilters from "./components/ProductosFilters";
import ProductosTable from "./components/ProductosTable";
import ExportExcelButton from "./components/ExportExcelButton";
import { getProductosEntregas } from "../../../services/financiero/productosEntregasService";

export default function ProductosEntregasPage() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [filters, setFilters] = useState({
    po: null,
    municipio: null,
    proyecto: null
  });

  // 🔹 CARGAR DATA
  useEffect(() => {
    const loadData = async () => {
      const res = await getProductosEntregas();
      setData(res);
      setFilteredData(res);
    };

    loadData();
  }, []);

  // 🔥 FILTROS
  useEffect(() => {
    let result = [...data];

    // 🔹 FILTRO POR PO
    if (filters.po) {
      result = result.filter(d =>
        String(d.Numero_PO || "")
          .toLowerCase()
          .includes(filters.po.toLowerCase())
      );
    }

    // 🔹 FILTRO POR MUNICIPIO
    if (filters.municipio) {
      result = result.filter(
        d => (d.municipio || "") === filters.municipio
      );
    }

    // 🔹 FILTRO POR PROYECTO
    if (filters.proyecto) {
      result = result.filter(
        d => (d.codigo_proyecto || "") === filters.proyecto
      );
    }

    setFilteredData(result);
  }, [filters, data]);

  // 🔹 MANEJAR CAMBIO DE FILTRO
  const handleFilter = (type, value) => {
    setFilters(prev => ({
      ...prev,
      [type]: value || null
    }));
  };

  // 🔹 LIMPIAR FILTROS
  const clearFilters = () => {
    setFilters({
      po: null,
      municipio: null,
      proyecto: null
    });
    setFilteredData(data);
  };

  // 🔥 OPCIONES LIMPIAS

  const municipios = [
    ...new Set(data.map(d => d.municipio).filter(Boolean))
  ];

  const pos = [
    ...new Set(data.map(d => d.Numero_PO).filter(Boolean))
  ];

  const proyectos = [
    ...new Map(
      data
        .filter(d => d.codigo_proyecto)
        .map(d => [
          d.codigo_proyecto,
          {
            codigo: d.codigo_proyecto,
            proyecto: d.nombre_proyecto || d.codigo_proyecto
          }
        ])
    ).values()
  ];

  return (
    <div className="container">
      <ProductosHeader />

      <ProductosFilters
        municipios={municipios}
        pos={pos}
        proyectos={proyectos}
        filters={filters}
        onFilter={handleFilter}
        onClear={clearFilters}
        extra={<ExportExcelButton data={filteredData} />}
      />

      <ProductosTable data={filteredData} />
    </div>
  );
}